$(document).ready(() => {
  const surveyStatus = localStorage.getItem("CLOUD_SURVEY");
  // only show on homepage
  const isHomepage = window.location.pathname === "/";
  if (isHomepage && !surveyStatus && BatchGeoStore.getState().App.pro) {
    const onSurveyComplete = () => {
      $.colorbox.close();
    };

    $.colorbox({
      width: "700px",
      inline: true,
      scroll: true,
      href: "#survey-container",
      onClosed: function () {
        localStorage.setItem("CLOUD_SURVEY", "completed");
      },
    });

    const inputContainers = $(".survey-input-container");
    inputContainers.each(function () {
      const inputContainer = $(this);
      inputContainer.on("click", () => {
        const isSelected = inputContainer.hasClass("selected");
        inputContainer.toggleClass("selected");
        inputContainer.find("input").first().prop("checked", !isSelected);
      });
    });

    $("#survey-form").on("submit", (e) => {
      e.preventDefault();
      const fields = {};
      $("#survey-form :input[type=radio]").each(function () {
        const input = $(this);
        fields[input.attr("name")] = input.prop("checked") ? 1 : 0;
      });

      const otherInput = $("#other-input");
      fields[otherInput.attr("name")] = otherInput.val();

      $.ajax({
        type: "POST",
        url: "/api/survey/",
        contentType: "application/json",
        data: JSON.stringify({ fields }),
        complete: () => {
          onSurveyComplete();
        },
      });
    });
  }
});
